import * as React from "react";
import { Offer } from "./Cruise";
import * as style from "./Cruise.style";
import { Helmet } from "react-helmet";
import krakenImage from "../../../public/assets/kraken-on-water.jpeg";

const KrakenContent: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="The Kraken - The only double-decker pontoon with a slide on Rehoboth Bay. Perfect for bachelorette parties, families, and groups. Book Now!"
        />
        <title>The Kraken - Double Decker Pontoon Boat Rental Dewey Beach</title>
      </Helmet>
      <div className={style.subHeader}>Description:</div>
      <div className={style.details}>
        The only double-decker pontoon with a slide on Rehoboth Bay, the Kraken
        is built for unforgettable days on the water. It's a go-to for
        bachelorette parties on the weekends, while weekdays transform it into
        the perfect family-friendly adventure.
      </div>
      <div className={style.details}>
        The Kraken cruises to the bay's most popular swimming spots and deeper
        sandbars, and while it's slightly slower than the Octolounge, it more
        than makes up for it with extra space, a rooftop sun deck, a slide, and
        nonstop fun. Don't forget about the attached inflatable dock that
        creates the ideal space to relax, float, and soak it all in.
      </div>
      <div className={style.subHeader}>Popular trips include:</div>
      <div className={style.details}>
        • Slide &amp; Swim Trips
        <br />
        • Sandbar Trips (dependent on tides)
        <br />
        • Canal Cruises
        <br />
        • Sunset Swims
        <br />• Morning Swims
      </div>
    </>
  );
};

const Kraken: React.FC = () => {
  return (
    <Offer
      title="The Kraken"
      description="2, 3, or 4 Hour Options &bull; All Ages &bull; Private Group of Up to 13 People"
      imageSrc={krakenImage}
      imageAlt="The Kraken Double Decker Pontoon Boat"
      children={<KrakenContent />}
    />
  );
};

Kraken.displayName = "Kraken";
export { Kraken };
